/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiScopeOverviewGet } from '../fn/scope/api-scope-overview-get';
import { ApiScopeOverviewGet$Params } from '../fn/scope/api-scope-overview-get';
import { apiScopeSyncPost } from '../fn/scope/api-scope-sync-post';
import { ApiScopeSyncPost$Params } from '../fn/scope/api-scope-sync-post';
import { ScopeOverviewList } from '../models/scope-overview-list';


/**
 * Scope service
 */
@Injectable({ providedIn: 'root' })
export class ScopeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiScopeOverviewGet()` */
  static readonly ApiScopeOverviewGetPath = '/api/scope/overview';

  /**
   * Get scope overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiScopeOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiScopeOverviewGet$Response(params?: ApiScopeOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ScopeOverviewList>> {
    return apiScopeOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get scope overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiScopeOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiScopeOverviewGet(params?: ApiScopeOverviewGet$Params, context?: HttpContext): Observable<ScopeOverviewList> {
    return this.apiScopeOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ScopeOverviewList>): ScopeOverviewList => r.body)
    );
  }

  /** Path part for operation `apiScopeSyncPost()` */
  static readonly ApiScopeSyncPostPath = '/api/scope/sync';

  /**
   * Upsert a/some scope/s.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiScopeSyncPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiScopeSyncPost$Response(params: ApiScopeSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiScopeSyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert a/some scope/s.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiScopeSyncPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiScopeSyncPost(params: ApiScopeSyncPost$Params, context?: HttpContext): Observable<void> {
    return this.apiScopeSyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
